<script setup>
import { ref, watch, computed } from 'vue';
import { useOptionsStore } from '@/stores/options';
import { useApplicationStore } from '@/stores/application';
import { storeToRefs } from 'pinia';
import { useToast } from 'vue-toastification';
import { trans } from 'laravel-vue-i18n';
import FormManager from '@/components/Forms/FormManager.vue';
import NoteManager from '@/components/Notes/NoteManager.vue';
import DocumentManager from '@/components/Documents/DocumentManager.vue';

const { applicationStatusOptions } = storeToRefs(useOptionsStore());
const { update } = useApplicationStore();

const toast = useToast();

const props = defineProps({
    client: {
        type: Object,
        default: () => null
    }
});

const form = ref({
    status_id: null,
});

watch(() => props.client, (client) => {
    if (client) {
        form.value.status_id = client.application.status_id;
        form.value.hash = client.application.hash;
    }
}, { immediate: true });

const saveApplicationStatus = async () => {
    try {
        await update(form.value);
        toast.success(trans('label.saved'));
    } catch (error) {
        toast.error(trans('label.error'));
    }
};

const client = computed(() => props.client);

</script>

<template>
<div>
    <div class="md:grid md:grid-cols-2 md:gap-4 md:w-2/3 p-2">
        <StyledDropdown
            v-model="form.status_id"
            :placeholder="$t('label.client_application_status')"
            :options="applicationStatusOptions"
            name="client_application_status"
            :label="$t('label.client_application_status')" />
    </div>

    <v-btn @click="saveApplicationStatus">{{ $t('label.save') }}</v-btn>

    <v-divider class="col-span-full my-4" />

    <FormManager 
        v-if="client.application"
        type="application" 
        :formable="client.application" />

    <v-divider class="col-span-full my-4" />

    <NoteManager
        v-if="client.application"
        type="application"
        :noteable="client.application" />

    <v-divider class="col-span-full my-4" />

    <div> 
        <DocumentManager 
            v-if="client.application"
            type="application"
            :documentable="client.application" />
    </div>
</div>
</template>
